<mbs-modal
  #modal
  [isCustomModal]="true"
  [loading]="loading()"
  [title]="'shared:storages.addModalTitle' | i18next">
  <ng-container modal-body>
    <div class="mbs-form-group">
      <div class="row">
        <div class="col">
          <mbs-smart-search
            [accessUrlQuery]="false"
            [data]="searchTemplates"
            [dropdownHeight]="270"
            [needClearOnDestroy]="true"
            (search)="updateFilters($event)" />
        </div>

        @if (canAddDestination && ability.can('read', PermissionsEnum.Storage)) {
          <div
            class="col-auto"
            [id]="elementSelectors.id.createNewAlert">
            <mbs-button
              icon="ico ico-Plus"
              (click)="openStorageWizard()">
              {{ 'shared:storages.addNewDestination' | i18next }}
            </mbs-button>
          </div>
        }
      </div>
    </div>

    <mbs-list-select
      [bindSelected]="'id'"
      [data]="filteredDestinations()"
      [filterFields]="'name'"
      [headers]="headers"
      [id]="'backup-destinations_list-select'"
      [mySelectedData]="selected()"
      [noDataMessage]="'shared:storages.allDestinationsAreAdded' | i18next"
      [selectOnlyOnCheckboxClick]="false"
      [showCounter]="false"
      [showHeaders]="false"
      [showSearch]="false"
      [striped]="false"
      [virtualItemsNumber]="7"
      [virtualScrolling]="true"
      (changeSelected)="changeSelected($event)">
      <ng-template
        let-destination
        mbsTableCell>
        <div class="mb-2">
          <div class="d-flex align-items-center">
            <i [class]="'flex-shrink-0 mr-2 mbs-storage mbs-storage-sm mbs-storage_' + (destination.storageType | storageIcon)"></i>
            <h6 class="m-0 overflow-hidden">
              <mbs-text-ellipsis
                [placement]="'top-left auto'"
                [tooltip]="destination.destinationName"
                [tooltipClass]="'tooltip-lg'">
                {{ destination.destinationName }}
              </mbs-text-ellipsis>
            </h6>
          </div>
        </div>

        @if (destination.storageAccountName; as storageAccountName) {
          <div class="row py-1">
            <div class="col-5 text-muted">
              {{ 'shared:storages.storageAccountName' | i18next }}
            </div>
            <div class="col-7 text-overflow">
              {{ storageAccountName }}
            </div>
          </div>
        }

        @if (StorageType.AzureVM !== destination.storageType) {
          <div class="row py-1">
            <div class="col-5 text-muted">
              {{ getDestinationKey(destination.storageType) }}
            </div>
            <div class="col-7">
              @if (destination.bucketName; as bucketName) {
                <div class="text-overflow">
                  {{ bucketName }}
                </div>
              } @else {
                <span
                  class="text-warning"
                  [ngbTooltip]="'This account does not contain buckets. Edit backup destination'">
                  <i class="ico ico-info-circle"></i>
                </span>
                {{ 'shared:emptyValue' | i18next }}
              }
            </div>
          </div>
        }

        @if (destination.region?.displayName; as regionDisplayName) {
          <div class="row py-1">
            <div class="col-5 text-muted">
              {{ 'shared:storages.region' | i18next: { format: 'title' } }}
            </div>
            <div class="col-7 text-overflow">
              {{ regionDisplayName }}
            </div>
          </div>
        }

        @if (showStorageState(destination.storageAccountState)) {
          <div class="row py-1">
            <div class="col-5 text-muted">
              {{ 'shared:storages.state' | i18next: { format: 'title' } }}
            </div>
            <div class="col-7 text-overflow">
              {{ transformStorageStateValue(destination.storageAccountState) }}
            </div>
          </div>
        }
      </ng-template>
    </mbs-list-select>
  </ng-container>

  <ng-container modalFooter>
    @if (withLimits) {
      <div
        class="d-flex flex-row align-items-center mr-auto"
        [style.width.%]="70">
        <div>
          <label
            class="mb-0"
            [for]="'mbs-backup-destination-modal-limits'">
            {{ 'shared:storages.storageLimit' | i18next: { format: 'title' } }}
          </label>
        </div>

        <div class="ml-2 w-50">
          <mbs-select
            [appendTo]="'body'"
            [bindLabel]="'name'"
            [clearable]="false"
            [formControl]="storageLimitsControl"
            [id]="'mbs-backup-destination-modal-limits'"
            [items]="storageLimits()"
            [searchable]="false" />
        </div>
      </div>
    }

    <mbs-button
      [disabled]="!selected()?.length"
      [type]="'primary'"
      (click)="onAddButtonClick()">
      {{ 'shared:buttons.add' | i18next }}
    </mbs-button>

    <mbs-button
      [type]="'secondary'"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
